import React from 'react';

export default function Loader(props) {
	return (
		<div className={props.isLoading ? "loader" : "hidden"}>
			<svg className="spinner" width="50px" height="50px" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
				<circle className="path" fill="none" strokeWidth="4" strokeLinecap="round" cx="27" cy="27" r="25"></circle>
			</svg>
			{props.children}
		</div>
	);
}
